// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g9o1","colBig":"styles_colBig__3e4R_","colSmall":"styles_colSmall__1SIjE"};